module.exports = __webpack_public_path__ + "media/packs/images/flags/IN-a5e6160e0d72e1cbbeae365813f11a18.png";